module.exports = __webpack_public_path__ + "img/img_logo_p2ps.13197201.svg";